import { MessageBar, MessageBarType } from '@fluentui/react';
import { nextMonthUtc } from '../../../../../util';
import React from 'react';

const IncompleteMonthWarning = ({ year, month }) => {
    var currentDateTime = new Date();
    var endOfDrawingDate = nextMonthUtc(year, month);

    if (currentDateTime > endOfDrawingDate) {
        return <></>;
    }

    return (
        <MessageBar messageBarType={MessageBarType.severeWarning}>
            It is currently {currentDateTime.toUTCString()} and entries will not be finished submitting for the selected
            month until {endOfDrawingDate.toUTCString()}.
        </MessageBar>
    );
};

export default IncompleteMonthWarning;
